import React from "react";
import { Button } from "@/components/ui/button";
import { ERROR_BOUNDARY } from "@/constants/testIds";

// AUD-003 — sem isto, um erro de render em qualquer página deixava a
// aplicação inteira em ecrã branco. Classe (não hook): React só suporta
// getDerivedStateFromError/componentDidCatch em componentes de classe.
export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Mecanismo de registo já existente no projeto (console.error) — sem
    // introduzir nova plataforma de observabilidade neste bloco.
    console.error("Erro de renderização não tratado:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid={ERROR_BOUNDARY.root}
          className="min-h-screen flex items-center justify-center bg-surface-bg px-4"
        >
          <div className="max-w-sm w-full text-center">
            <h1 className="text-lg font-semibold text-ink-primary mb-2">Ocorreu um erro inesperado</h1>
            <p className="text-sm text-ink-secondary mb-6">
              Algo correu mal ao apresentar esta página. Pode tentar novamente ou recarregar a aplicação.
            </p>
            <div className="flex items-center justify-center gap-3">
              <Button data-testid={ERROR_BOUNDARY.retry} variant="outline" onClick={this.handleRetry}>
                Tentar novamente
              </Button>
              <Button data-testid={ERROR_BOUNDARY.reload} onClick={this.handleReload}>
                Recarregar
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
